import { Drawer } from 'antd';
// import { useEffect, useState } from 'react'
import { useEffect, useState, useCallback, useRef } from 'react';
import { followingList, followerList } from "@/apis/user";
import UserCard from '@/components/UserCard';
import styles from './index.module.scss';
import intl from "react-intl-universal";

const Follow = ({ open, setOpen, title, changeFollow }) => {
	// const [list, setList] = useState([]);
	const [items, setItems] = useState([]);
	const [page, setPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const observer = useRef();
	const loaderRef = useRef();
	const modalContentRef = useRef();
	const initialLoadDone = useRef(false);
	const onClose = () => {
		setOpen(false)
	}

	const loadMore = useCallback(async () => {
		if (loading || !hasMore || !open) return;
		setLoading(true);
		try {
			let response = null
			if (title === "Following") {
				response = await followingList({
					currentPage: page,
					pageSize: 10
				});
			} else if (title === "Followers") {
				response = await followerList({
					currentPage: page,
					pageSize: 10
				});
			}
			const newItems = response.data.records;
			if (newItems.length === 0) {
				setHasMore(false);
				return;
			}

			setItems(prev => [...prev, ...newItems]);
			setPage(prev => prev + 1);
		} finally {
			setLoading(false);
		}
	}, [page, loading, hasMore, open]);

	useEffect(() => {
		if (!open || !modalContentRef.current) return;
		if (observer.current) observer.current.disconnect();
		observer.current = new IntersectionObserver(entries => {
			// 关键：弹窗内容高度不足时才不触发
			const modalHeight = modalContentRef.current?.clientHeight || 0;
			const loaderHeight = loaderRef.current?.clientHeight || 0;
			const shouldSkip = modalHeight > loaderHeight * 3; // 弹窗高度大于加载器3倍时才触发
			if (entries[0].isIntersecting && hasMore && !loading && shouldSkip) {
				loadMore();
			}
		}, {
			root: modalContentRef.current,
			rootMargin: '0px 0px 100px 0px',
			threshold: 0.5 // 提高阈值
		});

		if (loaderRef.current) {
			observer.current.observe(loaderRef.current);
		}

		return () => {
			if (observer.current) observer.current.disconnect();
		};
	}, [loadMore, hasMore, loading, open]);

	// 弹窗打开时加载第一页
	useEffect(() => {
		if (open && items.length === 0 && hasMore && !initialLoadDone.current) {
			loadMore();
			initialLoadDone.current = true;
		}
	}, [open, items.length, hasMore, loadMore]);


	const interact = (id, key, status) => {
		setItems(items.map(item => {
			if (item.uuid === id) {
				return { ...item, [key]: status }
			} else return item
		}))
		changeFollow(key, status)
	}
	// 弹窗关闭时重置
	useEffect(() => {
		if (!open) {
			initialLoadDone.current = false;
			setItems([]);
			setPage(1);
			setHasMore(true);
		}
	}, [open]);

	if (!open) return null;
	return <Drawer
		title={title}
		closable={{ 'aria-label': 'Close Button' }}
		onClose={onClose}
		open={open}
		size={500}
	>
		<div
			ref={modalContentRef}
			className={styles.drawerContent}
		>
			{
				items.map(item => <UserCard info={item} interact={interact} />)
			}

			{items.length > 0 && (
				<div ref={loaderRef} className={styles.bottomBox}>
					{loading && <div>{intl.get("loading")}</div>}
					{!hasMore && <div>{intl.get("All loaded")}</div>}
				</div>
			)}
		</div>
	</Drawer>
}
export default Follow;